var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.644,
    height: 18.53,
    viewBox: "0 0 20.644 18.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumbs_up_icon",
    "data-name": "thumbs up icon",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4355",
    "data-name": "Path 4355",
    d: "M3.21,6.591h.852c.487,0,.958-.5,1.308-.852C6.936,4.249,8.076,1.314,8.578.554a.865.865,0,0,1,.7-.3,1.229,1.229,0,0,1,.243.015c1.825.426,1.08,3.346.4,4.805-.091.182-.3.593-.3.608a.456.456,0,0,0,.411.578c.593.046.882.03,2.159.03h3.863a1.315,1.315,0,0,1,0,2.631H14.57m-1.962,5.231h1.46a1.315,1.315,0,0,1,0,2.631H8.32a5.978,5.978,0,0,1-2.844-.715c-.106-.061-.228-.122-.335-.182a2.756,2.756,0,0,0-1.293-.319H3.24",
    transform: "translate(1.291 -0.25)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4356",
    "data-name": "Path 4356",
    d: "M10.231,8.568H11.7a1.311,1.311,0,0,0,0-2.622H10.231",
    transform: "translate(4.947 2.716)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4357",
    "data-name": "Path 4357",
    d: "M9.868,10.292h1.467a1.311,1.311,0,1,0,0-2.622H9.868",
    transform: "translate(4.758 3.613)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4358",
    "data-name": "Path 4358",
    d: "M4.8,5.134v8.425a.74.74,0,0,1-.015.182,1.392,1.392,0,0,1-1.369,1.217H1.649a1.4,1.4,0,0,1-1.4-1.4V5.134a1.383,1.383,0,0,1,1.4-1.384H3.413A1.387,1.387,0,0,1,4.751,4.769,1.5,1.5,0,0,1,4.8,5.134Z",
    transform: "translate(-0.25 1.572)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpDark);
export default __webpack_public_path__ + "static/media/ThumbsUp-Dark.539f3fbcd443d412f2cab9978a8a8b38.svg";
export { ForwardRef as ReactComponent };